export const DEFAULT_MEDIA_UPLOAD_FETCH_MS = 30_000;

export function createDeadlineSignal(deadlineMs: number): {
  signal: AbortSignal;
  clearDeadline: () => void;
} {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, deadlineMs);
  return {
    signal: controller.signal,
    clearDeadline: () => {
      clearTimeout(timeoutId);
    },
  };
}
